import { useEffect, useState } from "react";

type NavPage = { title: string; href: string };
type NavGroup = { heading?: string; pages: NavPage[] };

const navGroups: NavGroup[] = [
  {
    pages: [
      { title: "Line Items", href: "/" },
      { title: "Xactimate Mappings", href: "/xactimate" },
      { title: "Rules Engine", href: "/rules-engine" },
      { title: "Deploy", href: "/deploy" },
    ],
  },
  {
    heading: "Documentation Config",
    pages: [
      { title: "Note Templates", href: "/responsive-note-templates" },
      { title: "Modules", href: "/modules" },
      { title: "Custom Prompts", href: "/custom-reese-prompts" },
    ],
  },
  {
    heading: "Org Config",
    pages: [
      { title: "Rate Cards", href: "/rate-cards" },
      { title: "Line Item Order", href: "/line-item-order" },
      { title: "General Room", href: "/general" },
      { title: "Estimate Export Headers", href: "/estimate-export-headers" },
      { title: "Custom Context", href: "/custom-context" },
    ],
  },
  {
    heading: "System Wide Config",
    pages: [
      { title: "MIT To Recon", href: "/mit-to-recon" },
      { title: "TPAs & Carriers", href: "/tpas-carriers" },
      { title: "Processor Config", href: "/processor-config" },
    ],
  },
  {
    heading: "Eval Set",
    pages: [{ title: "Manual Estimate Reviews", href: "/manual-estimate-reviews" }],
  },
];

const HamburgerIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);

const MappingTopBox: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <div className="w-full h-[72px] items-center inline-flex gap-4">
        <button
          type="button"
          aria-label="Open menu"
          className="p-2 -ml-2 rounded hover:bg-gray-100 text-gray-800 btn"
          onClick={() => setOpen(true)}
        >
          <HamburgerIcon />
        </button>
        <img src="/assets/ui/logo-black.svg" className="w-[85px] h-[22px]" />
      </div>

      <div
        className={`fixed inset-0 bg-black/40 z-[900] transition-opacity duration-200 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={() => setOpen(false)}
        aria-hidden={!open}
      />
      <aside
        className={`fixed top-0 left-0 h-full w-72 bg-white z-[901] shadow-xl flex flex-col transition-transform duration-200 ease-out ${open ? "translate-x-0" : "-translate-x-full"}`}
        aria-hidden={!open}
      >
        <div className="h-[72px] flex items-center px-4 gap-4 border-b border-gray-200 shrink-0">
          <button
            type="button"
            aria-label="Close menu"
            className="p-2 -ml-2 rounded hover:bg-gray-100 text-gray-800 btn"
            onClick={() => setOpen(false)}
          >
            <HamburgerIcon />
          </button>
          <img src="/assets/ui/logo-black.svg" className="w-[85px] h-[22px]" />
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2">
          {navGroups.map((group, i) => (
            <div key={i} className={i > 0 ? "mt-4 pt-4 border-t border-gray-200" : "mt-1"}>
              {group.heading && (
                <div className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-gray-400">{group.heading}</div>
              )}
              {group.pages.map((page) => (
                <a
                  key={page.href}
                  href={page.href}
                  className="block px-3 py-2 text-[15px] font-medium text-gray-700 rounded-md hover:bg-gray-100 hover:text-gray-900"
                >
                  {page.title}
                </a>
              ))}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default MappingTopBox;
